export default "__VITE_ASSET__265oZoru__"